import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ThemeSelectorService } from '../../../services';
import { FlowControlService } from '../../../digitalvenue/services/flow-control.service';

declare var Swiper: any;

@Component({
    selector: 'app-welcome-lexus-modal',
    templateUrl: './welcome-lexus-modal.component.html',
    styleUrls: ['./welcome-lexus-modal.component.scss']
})
export class WelcomeLexusModalComponent implements OnInit {
    slides = [];
    swiper = undefined;

    constructor(public bsModalRef: BsModalRef,
                private themeSelector: ThemeSelectorService,
                public flowControl: FlowControlService) {
    }

    ngOnInit() {
        this.slides = this.flowControl.lexusCarrouselImages;
        setTimeout(() => {
            this.swiper = new Swiper('.lexus-swiper', {
                slidesPerView: 1,
                spaceBetween: 5,
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },


            });
            this.swiper.update();
        }, 100);
    }

    getTheme() {
        return this.themeSelector.isDarkTheme;
    }
    decline(): void {
        this.bsModalRef.hide();
    }

}
